import { render, staticRenderFns } from "./headephone2.vue?vue&type=template&id=6a8ea0c5&scoped=true&"
import script from "./headephone2.vue?vue&type=script&lang=js&"
export * from "./headephone2.vue?vue&type=script&lang=js&"
import style0 from "./headephone2.vue?vue&type=style&index=0&id=6a8ea0c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8ea0c5",
  null
  
)

export default component.exports